export var CategoryPropType;
(function (CategoryPropType) {
    CategoryPropType["IMAGE"] = "image";
    CategoryPropType["TEXT"] = "text";
    CategoryPropType["URL"] = "url";
    CategoryPropType["COLORS"] = "colors";
    CategoryPropType["BOOLEAN"] = "boolean";
    CategoryPropType["NUMBER"] = "number";
    CategoryPropType["ARTICLE_CATEGORY"] = "articleCategory";
})(CategoryPropType || (CategoryPropType = {}));
export var CategoryDisplayType;
(function (CategoryDisplayType) {
    CategoryDisplayType["IMAGE"] = "image";
    CategoryDisplayType["COLORS"] = "colors";
    CategoryDisplayType["TEXT"] = "text";
    CategoryDisplayType["ARTICLE"] = "article";
    CategoryDisplayType["DISCUSSION"] = "discussion";
    CategoryDisplayType["TWEET"] = "tweet";
})(CategoryDisplayType || (CategoryDisplayType = {}));
export var CategoryKey;
(function (CategoryKey) {
    CategoryKey["FONT"] = "font";
    CategoryKey["PORTFOLIO"] = "portfolio";
    CategoryKey["BRANDING"] = "branding";
    CategoryKey["PALETTE"] = "palette";
    CategoryKey["LINK"] = "link";
    CategoryKey["PRODUCT"] = "product";
    CategoryKey["DRIBBBLE"] = "dribbble";
    CategoryKey["BEHANCE"] = "behance";
    CategoryKey["INSTAGRAM"] = "instagram";
    CategoryKey["ARTICLE"] = "article";
    CategoryKey["JOB"] = "job";
    CategoryKey["PODCAST"] = "podcast";
    CategoryKey["FEATURED"] = "featured";
    CategoryKey["DISCUSSION"] = "discussion";
    CategoryKey["TWEET"] = "tweet";
    CategoryKey["NFT"] = "nft";
    CategoryKey["YOUTUBE"] = "youtube";
    CategoryKey["FIGMA"] = "figma";
    CategoryKey["SPACE"] = "space";
})(CategoryKey || (CategoryKey = {}));
export var ProjectSettingValueType;
(function (ProjectSettingValueType) {
    ProjectSettingValueType["TEXT"] = "text";
    ProjectSettingValueType["SELECT"] = "select";
    ProjectSettingValueType["MULTI_SELECT"] = "multi-select";
    ProjectSettingValueType["BOOLEAN"] = "boolean";
})(ProjectSettingValueType || (ProjectSettingValueType = {}));
